import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footerx">
      <div className="footerx-container">
        <div className="footerx-grid">
          {/* Contact Us */}
          <div className="footerx-section">
            <h3 className="footerx-title">CONTACT US</h3>
            <address className="footerx-address">
              <p>
                HW 1121, Bharat Diamond Bourse,
                <br />
                Bandra Kurla Complex, Bandra (East),
                <br />
                Mumbai-400051, India
              </p>
              <p>
                <span>Email:</span>
                <br />
                <a href="mailto:net@pansuriyaimpex.com">
                  net@pansuriyaimpex.com
                </a>
              </p>
              <p>
                <span>Tel: </span>
                <a href="tel:+912240464444">(+91-22) 4046 4444</a>
              </p>
            </address>
          </div>

          {/* About Us */}
          <div className="footerx-section">
            <h3 className="footerx-title">ABOUT US</h3>
            <ul className="footerx-links">
              <li>
                <Link to="/about-us">What We Do</Link>
              </li>
              <li>
                <Link to="/tnc">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/benefits">Benefits</Link>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div className="footerx-section">
            <h3 className="footerx-title">FOLLOW US</h3>
            <div className="footerx-social-icons">
              <a
                href="https://www.facebook.com/pansuriyaimpex72/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="https://twitter.com/PansuriyaImpex"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="https://www.instagram.com/pansuriyaimpex72/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="http://www.youtube.com/pansuriyaimpex"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footerx-bottom">
          <p>
            &copy; {new Date().getFullYear()} Pansuriya Impex LLP. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
